
import { defineComponent } from 'vue'

interface ZTabListT extends Vue {
  getActiveIndex: number
}

const DEFAULT_BORDER_ACTIVE_COLOR = 'juniper'

export default defineComponent({
  name: 'ZTabItem',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    },
    updateActiveIndex: {
      type: Function,
      required: true
    },
    icon: {
      type: String
    },
    removeIndicatorStyles: {
      type: Boolean,
      default: false
    },
    borderActiveColor: {
      type: String,
      default: DEFAULT_BORDER_ACTIVE_COLOR
    }
  },
  computed: {
    activeIndex(): number {
      return (this.$parent as ZTabListT).getActiveIndex
    },
    isActive(): boolean {
      return this.index === this.activeIndex
    }
  },
  methods: {
    clickHandler() {
      if (!this.disabled) {
        this.updateActiveIndex()
      }
    }
  }
})
